import React, { useState, useEffect } from 'react';
import './TestimonialCarousel.css';

const TestimonialCarousel = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      position: 'CEO, TechStart Inc.',
      company: 'TechStart Inc.',
      image: '/images/testimonials/client1.jpg',
      rating: 5,
      text: 'Working with this company has been an absolute game-changer for our business. Their expertise in web development and digital marketing helped us increase our online presence by 300%. The team is professional, responsive, and truly understands our needs.'
    },
    {
      id: 2,
      name: 'Michael Chen',
      position: 'Marketing Director',
      company: 'Global Solutions',
      image: '/images/testimonials/client2.jpg',
      rating: 5,
      text: 'The mobile app they developed for us exceeded all expectations. The user interface is intuitive, the performance is outstanding, and our customers love it. We saw a 250% increase in user engagement within the first month of launch.'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      position: 'Founder',
      company: 'Creative Agency',
      image: '/images/testimonials/client3.jpg',
      rating: 5,
      text: 'Their digital marketing strategies transformed our brand visibility. We went from struggling to get noticed to becoming a recognized name in our industry. The ROI on our marketing investment has been phenomenal.'
    },
    {
      id: 4,
      name: 'David Thompson',
      position: 'CTO',
      company: 'Innovation Labs',
      image: '/images/testimonials/client4.jpg',
      rating: 5,
      text: 'The cloud migration project was handled flawlessly. They managed the entire process with minimal downtime and significant cost savings. Our system performance improved dramatically, and we now have the scalability we needed.'
    },
    {
      id: 5,
      name: 'Lisa Wang',
      position: 'Operations Manager',
      company: 'Retail Plus',
      image: '/images/testimonials/client5.jpg',
      rating: 5,
      text: 'From consultation to implementation, every step was handled with utmost professionalism. The e-commerce platform they built for us has streamlined our operations and boosted our sales by 180%. Highly recommended!'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  return (
    <div className="testimonial-carousel">
      <div className="testimonial-container">
        {testimonials.map((testimonial, index) => (
          <div
            key={testimonial.id}
            className={`testimonial-slide ${index === currentTestimonial ? 'active' : ''}`}
          >
            <div className="testimonial-content">
              <div className="testimonial-text">
                <div className="quote-icon">"</div>
                <p>{testimonial.text}</p>
              </div>
              <div className="testimonial-author">
                <div className="author-image">
                  <img src={testimonial.image} alt={testimonial.name} loading="lazy" />
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-position">{testimonial.position}</p>
                  <p className="author-company">{testimonial.company}</p>
                  <div className="rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Controls */}
      <button 
        className="carousel-nav carousel-nav-prev" 
        onClick={prevTestimonial}
        aria-label="Previous testimonial"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <button 
        className="carousel-nav carousel-nav-next" 
        onClick={nextTestimonial}
        aria-label="Next testimonial"
      >
        <i className="fas fa-chevron-right"></i>
      </button>

      {/* Indicators */}
      <div className="carousel-indicators">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`carousel-indicator ${index === currentTestimonial ? 'active' : ''}`}
            onClick={() => goToTestimonial(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default TestimonialCarousel;